import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable, inject } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IReleaseNotes } from '../../interfaces/IReleaseNotes';
import { ReleaseNotesService } from '../../services/releaseNotes.service';
import { LoadRecentReleaseNote, LoadReleaseNotes } from './releaseNotes.actions';

export interface IReleaseNotesModel {
  releaseNotes: IReleaseNotes[];
  latestReleaseNote: IReleaseNotes;
  isLoading: boolean;
}

@State<IReleaseNotesModel>({
  name: 'releaseNotesState',
  defaults: {
    releaseNotes: [],
    latestReleaseNote: null,
    isLoading: false,
  },
})
@Injectable()
export class ReleaseNotesState {
  private releaseNotesService = inject(ReleaseNotesService);

  @Selector()
  static latestReleaseNote(state: IReleaseNotesModel): IReleaseNotes {
    return state.latestReleaseNote;
  }

  @Selector()
  static releaseNotes(state: IReleaseNotesModel): IReleaseNotes[] {
    return state.releaseNotes;
  }

  @Selector()
  static isLoading(state: IReleaseNotesModel): boolean {
    return state.isLoading;
  }

  @Action(LoadRecentReleaseNote)
  LoadRecentReleaseNote(ctx: StateContext<IReleaseNotesModel>): Observable<IReleaseNotes> {
    this.setIsLoading(ctx, true);
    return this.releaseNotesService.getRecentReleaseNote().pipe(
      tap((result: IReleaseNotes) => {
        ctx.patchState({
          latestReleaseNote: result,
        });
      }),
      finalize(() => this.setIsLoading(ctx, false)),
    );
  }

  @Action(LoadReleaseNotes)
  LoadReleaseNotes(ctx: StateContext<IReleaseNotesModel>): Observable<IReleaseNotes[]> {
    this.setIsLoading(ctx, true);
    return this.releaseNotesService.getAllReleaseNotes().pipe(
      tap((result: IReleaseNotes[]) => {
        ctx.patchState({
          releaseNotes: result,
        });
      }),
      finalize(() => this.setIsLoading(ctx, false)),
    );
  }

  private setIsLoading(ctx: StateContext<IReleaseNotesModel>, isLoading: boolean): void {
    ctx.patchState({ isLoading });
  }
}
